import Wix from './wix-sdk-polyfill';
import { isEditor } from './wix-sdk-utils';
import { setViewMode } from '../actions/set-view-mode';

export default function listenToEditModeChange(store) {
  if (!isEditor()) {
    return;
  }

  store.dispatch(setViewMode(Wix.Utils.getViewMode()));

  Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, ({ editMode }) => {
    store.dispatch(setViewMode(editMode));
  });
}



// WEBPACK FOOTER //
// ./app/services/listen-to-edit-mode-change.js